export function encodeGlobalId(type: string, id: number): string {
	return Buffer.from(type + ':' + id).toString('base64');
}

function parseAndSplitGlobalId(globalId: string): string[] {
	return Buffer.from(globalId, 'base64').toString('utf8').split(':');
}

export function typeFromGlobalId(globalId: string): string {
	return parseAndSplitGlobalId(globalId)[0];
}

export function idFromGlobalId(globalId: string): number {
	return Number(parseAndSplitGlobalId(globalId)[1]);
}
